export default __webpack_public_path__ + "static/media/like.26d11055.svg";